import { render, staticRenderFns } from "./ListSelection.vue?vue&type=template&id=2f3cb106&scoped=true"
import script from "./ListSelection.vue?vue&type=script&lang=js"
export * from "./ListSelection.vue?vue&type=script&lang=js"
import style0 from "./ListSelection.vue?vue&type=style&index=0&id=2f3cb106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3cb106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
